import React, { useState, useRef, useCallback, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Request from "../../utils/http";

const request = new Request();

const incidenciaOptions = [
  { value: "1", label: "Roto" },
  { value: "2", label: "Fisurado" },
  { value: "3", label: "Estrellado" },
  { value: "4", label: "Despintado" },
  { value: "5", label: "Descarapelado" },
  { value: "6", label: "Rayado" },
  { value: "7", label: "Mojado" },
  { value: "8", label: "Manchado" },
  { value: "9", label: "Despegado" },
  { value: "10", label: "Quebrado" },
  { value: "11", label: "Extraviado por un invitado" },
  { value: "12", label: "Extraviado por el personal del hotel" },
];

const IncidentForm = (props) => {
  const [formData, setFormData] = useState({
    idIncidencia: "",
    cantidad: 1,
    foto: null,
    preview: null,
  });
  const [errors, setErrors] = useState({});
  const [submittedData, setSubmittedData] = useState([]);
  const [loading, setLoading] = useState(false);
  const fileInputRef = useRef();

  useEffect(() => {
    return () => {
      if (formData.preview) {
        URL.revokeObjectURL(formData.preview);
      }
    };
  }, [formData.preview]);

  useEffect(() => {
    fetchStoredData();
  }, [props.idArt, props.idEvento, props.sub, props.etapa]);

  const fetchStoredData = async () => {
    let token1 = JSON.parse(sessionStorage.getItem("decoAdmin"));
    let token;
    if (token1) {
      token = token1.id;
    }
    if (!token) {
      toast.error("No hay token de sesión disponible");
      return;
    }
    try {
      const postData = {
        token: token,
        idArt: props.idArt,
        idEvento: props.idEvento,
        etapa: props.etapa,
      };

      const response = await request.post(
        "/auth/inventory/buscarIncidencias",
        postData
      );
console.log(response);

      const fetchedData = response.result.map((item) => {
        return {
          idIncidencia: item.id_incidencia,
          cantidad: item.cantidad,
          label: item.incidencia,
          imageUrl: "https://sys.decocancun.com/laravel_api/public/inventario/" + item.foto,
        };
      });

      setSubmittedData(fetchedData);
    } catch (error) {
      console.error("Error al cargar incidencias:", error);
      toast.error("No se pudieron cargar las incidencias almacenadas");
    }
  };

  const handleChange = useCallback((field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  }, []);

  const handleFotoChange = useCallback((file) => {
    if (formData.preview) {
      URL.revokeObjectURL(formData.preview);
    }
    const preview = file ? URL.createObjectURL(file) : null;
    setFormData((prev) => ({ ...prev, foto: file, preview }));
  }, [formData.preview]);

  const validate = () => {
    let isValid = true;
    const newErrors = {};

    if (!formData.idIncidencia) {
      newErrors.idIncidencia = "Campo requerido";
      isValid = false;
    }
    if (!formData.cantidad || parseInt(formData.cantidad) < 1) {
      newErrors.cantidad = "Cantidad válida requerida";
      isValid = false;
    }
    if (!formData.foto) {
      newErrors.foto = "Foto requerida";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const clearForm = useCallback(() => {
    if (formData.preview) {
      URL.revokeObjectURL(formData.preview);
    }
    setFormData({ idIncidencia: "", cantidad: 1, foto: null, preview: null });
    setErrors({});
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  }, [formData.preview]);

  const handleSubmit = useCallback(async () => {
    let token1 = JSON.parse(sessionStorage.getItem("decoAdmin"));
    let token;
    if (token1) {
      token = token1.id;
    }
    if (!token) {
      toast.error("No hay token de sesión disponible");
      return;
    }

    if (!validate()) {
      toast.error("Por favor, complete todos los campos obligatorios");
      return;
    }

    setLoading(true);
    const data = new FormData();
    data.append("idArt", props.idArt);
    data.append("idEvento", props.idEvento);
    data.append("idSub", props.sub);
    data.append("etapa", props.etapa);
    data.append("idIncidencia", formData.idIncidencia);
    data.append("cantidad", parseInt(formData.cantidad, 10));
    data.append("foto", formData.foto);

    try {
      const response = await request.upload(
        "/auth/inventory/insertarIncidencia",
        data,
        token
      );
      console.log(response);

    fetchStoredData();

      clearForm();
      toast.success("Formulario enviado correctamente");
    } catch (error) {
      console.error("Error al enviar el formulario:", error);
      toast.error("Hubo un error al enviar el formulario");
    } finally {
      setLoading(false);
    }
  }, [formData, props, clearForm]);

  return (
    <>
      
      <div className="card mb-4">
        <div className="card-body">
          <div className="row">
            <div className="col-md-8">
              <div className="input-group mb-3">
                <label htmlFor="idIncidenciaField" className="input-group-text">
                  Incidente:
                </label>
                <select
                  id="idIncidenciaField"
                  className={`form-control ${errors.idIncidencia ? "is-invalid" : ""}`}
                  value={formData.idIncidencia}
                  onChange={(e) => handleChange("idIncidencia", e.target.value)}
                >
                  <option value="">Seleccione una incidencia</option>
                  {incidenciaOptions.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </select>
                {errors.idIncidencia && (
                  <div className="invalid-feedback">{errors.idIncidencia}</div>
                )}
              </div>

              <div className="input-group mb-3">
                <label htmlFor="cantidadField" className="input-group-text">
                  Cantidad
                </label>
                <input
                  id="cantidadField"
                  type="number"
                  className={`form-control ${errors.cantidad ? "is-invalid" : ""}`}
                  min="1"
                  value={formData.cantidad}
                  onChange={(e) => handleChange("cantidad", e.target.value)}
                />
                {errors.cantidad && (
                  <div className="invalid-feedback">{errors.cantidad}</div>
                )}
              </div>

              <div className="input-group mb-3">
                <label htmlFor="fotoField" className="input-group-text">
                  Foto
                </label>
                <input
                  id="fotoField"
                  type="file"
                  ref={fileInputRef}
                  className={`form-control ${errors.foto ? "is-invalid" : ""}`}
                  accept="image/*"
                  onChange={(e) => handleFotoChange(e.target.files[0])}
                />
                {errors.foto && <div className="invalid-feedback">{errors.foto}</div>}
              </div>
              <div className="d-flex justify-content-between">
                <button className="btn btn-outline-danger" onClick={clearForm} disabled={loading}>
                  <i className="fas fa-eraser"></i>&nbsp;Limpiar
                </button>
                <button className="btn btn-primary" onClick={handleSubmit} disabled={loading}>
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm"></span>&nbsp;Guardando...
                    </>
                  ) : (
                    <>
                      <i className="fas fa-save"></i>&nbsp;Guardar
                    </>
                  )}
                </button>
              </div>
            </div>
            <div className="col-md-4">
              {formData.preview && (
                <div className="mt-2">
                  <img
                    src={formData.preview}
                    alt="Vista previa"
                    className="img-thumbnail"
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {submittedData.length > 0 && (
        <div className="mt-4 w-100" style={{ maxWidth: "600px" }}>
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>ID-Incidencia</th>
                <th>Cantidad</th>
                <th>Foto</th>
              </tr>
            </thead>
            <tbody>
              {submittedData.map((data, index) => (
                <tr key={index}>
                  <td>{`${data.idIncidencia} - ${data.label}`}</td>
                  <td>{data.cantidad}</td>
                  <td>
                    <img
                      src={data.imageUrl}
                      alt="Foto"
                      width={100}
                      className="img-thumbnail"
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
};

export default IncidentForm;
